import React from "react";

export const CONTAINER_COLORS = [
  { value: "#3B82F6", label: "Blu" },
  { value: "#EF4444", label: "Rosso" },
  { value: "#22C55E", label: "Verde" },
  { value: "#F97316", label: "Arancione" },
  { value: "#EAB308", label: "Giallo" },
  { value: "#A855F7", label: "Viola" },
  { value: "#EC4899", label: "Rosa" },
  { value: "#38BDF8", label: "Azzurro" },
  { value: "#6366F1", label: "Indaco" },
  { value: "#14B8A6", label: "Teal" },
  { value: "#D946EF", label: "Fucsia" },
  { value: "#FB923C", label: "Arancio chiaro" },
];

export const DEFAULT_CONTAINER_COLOR = "#3B82F6";

type Props = {
  value: string;
  onChange: (color: string) => void;
};

export const ColorPicker: React.FC<Props> = ({ value, onChange }) => (
  <div className="flex flex-wrap gap-2">
    {CONTAINER_COLORS.map((c) => (
      <button
        key={c.value}
        type="button"
        onClick={() => onChange(c.value)}
        className={`w-8 h-8 rounded-full border-2 transition-all ${
          value === c.value
            ? "border-gray-900 dark:border-white scale-110 shadow-md"
            : "border-transparent hover:scale-105"
        }`}
        style={{ backgroundColor: c.value }}
        title={c.label}
      />
    ))}
  </div>
);
